import i18n from 'i18next';

/**
 * Returns the localized title for a dropdown option.
 * Checks translations[currentLanguage] first, falls back to title.
 *
 * @param {Object} option - Dropdown option with `title` and optional `translations` fields
 * @returns {string} Localized title
 */
export function getLocalizedTitle(option) {
    if (!option) return '';
    const lang = i18n.language || 'en';
    if (option.translations && option.translations[lang]) {
        return option.translations[lang];
    }
    return option.title || '';
}

/**
 * Returns the localized name for an address item.
 * Checks translations[currentLanguage] first, falls back to name.
 *
 * @param {Object} option - Address item with `name` and optional `translations` fields
 * @returns {string} Localized name
 */
export function getLocalizedName(option) {
    if (!option) return '';
    const lang = i18n.language || 'en';
    if (option.translations && option.translations[lang]) {
        return option.translations[lang];
    }
    return option.name || '';
}

/**
 * Returns the localized value for a field that is an object with language keys.
 * e.g. { en: "Technical Report", ar: "تقرير فني" }
 *
 * @param {Object} field - Object with language code keys
 * @returns {string} Localized value
 */
export function localizeField(field) {
    if (!field) return '';
    if (typeof field === 'string') return field;
    const lang = i18n.language || 'en';
    return field[lang] || field['en'] || Object.values(field)[0] || '';
}
